export default __webpack_public_path__ + "static/media/6.41c80a8b.svg";